import { render, staticRenderFns } from "./SelectCompanyStatuses.vue?vue&type=template&id=68500b70"
import script from "./SelectCompanyStatuses.vue?vue&type=script&lang=js"
export * from "./SelectCompanyStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports